export default "__VITE_ASSET__DGUNPCu___"